<template>
  <div
    class="media align-items-center p-2 border rounded"
    :class="{ 'player-card--disabled': disabled }"
    :style="{ cursor: disabled ? 'default' : 'pointer' }"
    @click="onClick"
  >
    <div class="position-relative mr-3 flex-shrink-0">
      <img
        :src="player.profile || '/empty-player.jpg'"
        class="img-avatar img-avatar48 rounded-circle"
        :alt="player.name"
      >
      <span
        v-if="jersey != null && jersey !== ''"
        class="badge position-absolute"
        :class="jerseyIsSuggestion ? 'badge-secondary' : 'badge-primary'"
        style="bottom: -4px; right: -6px; font-size: 10px;"
      >{{ jersey }}</span>
    </div>
    <div class="media-body min-width-0">
      <div class="font-w600 text-truncate">{{ player.lastName }}</div>
      <div class="font-w600 text-truncate">{{ player.firstName }}</div>
      <div v-if="player.birthYear" class="text-muted small">{{ player.birthYear }}</div>
      <slot></slot>
    </div>
    <slot name="aside"></slot>
  </div>
</template>

<script>
/**
 * Player card with the profile photo, the jersey number badge and the name.
 * Used for the player photos screen and the swap player list.
 */
export default {
  name: 'PlayerCard',
  props: {
    player: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    // Show the usual jersey number of the player (muted badge) when he has no jersey in this game
    showSuggestion: { type: Boolean, default: false }
  },
  computed: {
    jersey () {
      if (this.player.number_of_jersey != null && this.player.number_of_jersey !== '') {
        return this.player.number_of_jersey
      }

      return this.showSuggestion ? this.player.number_of_jersey_suggestion : null
    },
    jerseyIsSuggestion () {
      return this.player.number_of_jersey == null || this.player.number_of_jersey === ''
    }
  },
  methods: {
    onClick () {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script>

<style scoped>
.player-card--disabled {
  opacity: 0.55;
}
</style>
